import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IDashboard } from "../services/dashboardService";
import { Preferences } from "@capacitor/preferences";

export const DASHBOARD_STORAGE_NAME = "dashboard-storage";

interface DashboardState {
  dashboard: IDashboard | null;
  isLoading: boolean;
  isInitialLoaded: boolean;
  setDashboard: (dashboard: IDashboard) => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsInitalLoaded: (isInitialLoaded: boolean) => void;
  reset: () => void;
}

const capacitorPreferencesStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: (key: string, value: string) => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string) => {
    return Preferences.remove({ key });
  },
};

const useDashboardStore = create<DashboardState>()(
  devtools(
    persist(
      (set) => ({
        dashboard: null,
        isLoading: true,
        isInitialLoaded: false,
        setDashboard: (dashboard: IDashboard) => set({ dashboard }),
        setIsLoading: (isLoading: boolean) => set({ isLoading }),
        setIsInitalLoaded: (isInitialLoaded: boolean) =>
          set({ isInitialLoaded }),
        reset: () => {
          set({
            dashboard: null,
            isLoading: true,
            isInitialLoaded: false,
          });
        },
      }),
      {
        name: DASHBOARD_STORAGE_NAME,
        storage: createJSONStorage(() => capacitorPreferencesStorage),
      }
    )
  )
);

export default useDashboardStore;
